export default __webpack_public_path__ + "static/media/codecanyon.f9a1a1ed.png";